import React, { Component } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import MobileNotification from "../common/MobileNotification";
import Button from "../common/Button";
import Schedule from "../common/Schedule";
import OverviewCard from "./OverviewCard";
import CustomBarChart from "./CustomBarChart";
import CustomPieChart from "./CustomPieChart";
import { Steps, Hints } from "intro.js-react";
import Onboarding from "../Onboarding/Onboarding";
import { cloneDeep } from "lodash";
import MobileHeaderSearch from "../common/MobileHeaderSearch";
import { appBasePath } from "../../constants/staticData";

export default class VendorProfile extends Component {
  constructor(props, context) {
    super(props, context);
    this.toggleNotification = this.toggleNotification.bind(this);
    const authData = localStorage.businessAuthData
      ? JSON.parse(localStorage.businessAuthData)
      : "";
    document.title = props.pageTitle;


    //console.log("authData: --------------- ", authData);
    this.state = {
      searchMobile: false,
      stepsEnabled: authData && authData.onboardingDone == false  && authData.businessstatus && authData.businessstatus !== 1? true : false,
      initialStep: 0,
      showWalkthrough: false,
      steps: [
        {
          element: ".notify.emg",
          intro: "Get instant emergency notifications."
        },
        {
          element: ".notify.notification",
          intro: "Get instant notifications of all your activities."
        },
        {
          element: ".notify.msg",
          intro: "Get customer message notification."
        },
        {
          element: ".toggleBtn.mobilehide",
          intro: "Send instant quote to customers"
        },
        {
          element: ".header-search .searchBar",
          intro: "Search jobs of your preference"
        },
        {
          element: ".overview-card#rating-sec",
          intro: " Get updates on your ratings"
        }
      ],
      notificationVisible: false,
      showSidebar: false,
      chartView: "week",
      isTopLocationLoading: true,
      isTopServicesLoading: true,
      isJobForTodayLoading: true,
      isJobDistributionLoading: true
    };
  }
  componentWillMount() {
    const { commonReducer } = this.props;
    if (!commonReducer.isTopLocationLoaded) {
      this.props.actions.getTopLocations();
    }
    if (!commonReducer.isTopServicesLoaded) {
      this.props.actions.getTopServices();
    }
    if (!commonReducer.isJobForTodayLoaded) {
      this.props.actions.getJobForToday();
    }
    if (!commonReducer.isJobDistributionLoaded) {
      this.props.actions.getJobDistributionChart();
    }
    this.props.actions.getOverview();
  }

  componentDidMount() {
    const authData = localStorage.businessAuthData
    ? JSON.parse(localStorage.businessAuthData)
    : "";

    console.log("---------------: ");
    console.log("authData: ",authData);

    if ((authData && authData.businessstatus === 1) ||
      (authData && authData.isFirstTimeLoggedin)) {
      this.props.router.push(`${appBasePath}/non-verified`);
    }


    if(this.state.stepsEnabled){


      authData.onboardingDone = true;
      localStorage.setItem("businessAuthData", JSON.stringify(authData));

      this.props.actions.onboardingDone();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.commonReducer.isTopLocationLoaded &&
      this.state.isTopLocationLoading
    ) {
      this.setState({
        isTopLocationLoading: false
      });
    }
    if (
      nextProps.commonReducer.isTopServicesLoaded &&
      this.state.isTopServicesLoading
    ) {
      this.setState({
        isTopServicesLoading: false
      });
    }
    if (
      nextProps.commonReducer.isJobForTodayLoaded &&
      this.state.isJobForTodayLoading
    ) {
      this.setState({
        isJobForTodayLoading: false
      });
    }
    if (
      nextProps.commonReducer.isJobDistributionLoaded &&
      this.state.isJobDistributionLoading
    ) {
      this.setState({
        isJobDistributionLoading: false
      });
    }
  }
  onExit() {
    this.setState(() => ({ showWalkthrough: false }));
    const authData = localStorage.businessAuthData
      ? JSON.parse(localStorage.businessAuthData)
      : "";

    console.log("authData.businessstatus",authData.businessstatus)
    console.log("authData.onboardingDone",authData.onboardingDone)
    console.log("authData.isBusinessRegistered",authData.isBusinessRegistered)





  }
  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }
  chartView(chartType, e) {
    if (chartType == "month") {
      this.setState({ chartView: "month" });
    } else {
      this.setState({ chartView: "week" });
    }
  }
  render() {
    const { commonReducer, actions } = this.props;
    return (
      <div>
        {this.state.stepsEnabled && (
          <Onboarding
            closeAction={() => {
              this.setState({ stepsEnabled: false, showWalkthrough: true });
            }}
          />
        )}
        <Steps
          enabled={this.state.showWalkthrough}
          steps={this.state.steps}
          initialStep={this.state.initialStep}
          onExit={this.onExit.bind(this)}
          options={{
            highlightClass: "custom-highlight",
            showStepNumbers: false,
            showProgress: false,
            doneLabel: "Done",
            skipLabel: "",
            tooltipClass: "dashbaord-intro",
            showBullets: false,
            nextLabel: "Next",
            prevLabel: "Previous"
          }}
        />
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          customClass={this.state.showWalkthrough ? "walkthrough" : ""}
          commonReducer={this.props.commonReducer}
          actions={this.props.actions}
          notificationCount={2}
          profileName="Derrick Frank"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={this.props.router}
        />
        <MobileNotification
          isVisible={this.state.notificationVisible}
          backBtnCallBack={this.toggleNotification}
        />
        <div className="main-wrapper">
          {/*Sidebar*/}
          <Sidebar
            showSidebar={this.state.showSidebar}
            router={this.props.router}
            actions={this.props.actions}
            commonReducer={this.props.commonReducer}
            authReducer={this.props.authReducer}
          />
          <div className="container-fluid main-container">
            <div className="col-md-9 mpad0">
              <div className="overview-heading">
                <h5>Overview</h5>
              </div>
              <CustomPieChart
                jobDistributionChart={commonReducer.jobDistributionChart}
                isLoading={this.state.isJobDistributionLoading}
              />
              <CustomBarChart
                Chartdata={
                  commonReducer.overviewData &&
                  cloneDeep(commonReducer.overviewData.winloss)
                }
                monthView={this.chartView.bind(this, "month")}
                weekView={this.chartView.bind(this, "week")}
                title={
                  this.state.chartView == "month" ? "This Month" : "This Week"
                }
                isLoading={!this.props.commonReducer.overviewLoaded}
              />

              <OverviewCard
                title="JOB FOR TODAY"
                gridType="3"
                isJobForTheDay={true}
                jobForTheDay={commonReducer.overviewData.jobfortheday}
                isLoading={this.state.isJobForTodayLoading}
              />
              <OverviewCard
                title="RATING THIS WEEK"
                gridType="3"
                ratingThisWeek={commonReducer.overviewData.rating}
                isLoading={false}
              />
              <OverviewCard
                title="TOP 5 REQUESTED SERVICES"
                gridType="6"
                topServices={commonReducer.topServices}
                isLoading={this.state.isTopServicesLoading}
              />
              <OverviewCard
                title="ACTIVITY"
                gridType="6"
                activities={commonReducer.overviewData.activities}
                router={this.props.router}
              />
              <OverviewCard
                title="TOP 5 LOCATIONS"
                gridType="6"
                topLocations={commonReducer.topLocations}
                isLoading={this.state.isTopLocationLoading}
              />
            </div>
            <div className="col-md-3 mpad0 padLeft0">
              <Schedule
                commonReducer={this.props.commonReducer}
                router={this.props.router}
              />
            </div>
          </div>
        </div>
        {this.state.searchMobile && (
          <div>
            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Overview/Overview.jsx